
import { useAuth } from '@/context/AuthContext';
import { useActiveCampaigns } from './modal-campaigns/useActiveCampaigns';
import { useQuizState } from './modal-campaigns/useQuizState';
import { useModalDismissal } from './modal-campaigns/useModalDismissal';

export const useModalCampaigns = () => {
  const { user } = useAuth();
  
  // Use the extracted hooks
  const {
    loading,
    currentCampaign,
    questions,
    showModal,
    currentLog,
    attemptNumber,
    setShowModal,
    setCurrentCampaign,
    setQuestions,
    setCurrentLog,
    setAttemptNumber
  } = useActiveCampaigns();

  const {
    userAnswers,
    quizSubmitted,
    quizPassed,
    score,
    currentQuestionIndex,
    handleAnswer,
    submitQuiz,
    resetQuiz,
    goToPreviousQuestion,
    goToNextQuestion
  } = useQuizState(attemptNumber);

  const { canDismiss, dismissModal: dismiss } = useModalDismissal(
    currentCampaign, 
    quizPassed,
    score,
    () => {
      setShowModal(false);
      setCurrentCampaign(null);
      setQuestions([]);
      setCurrentLog(null);
    }
  );

  // Wrapper for the dismiss function to pass the log ID
  const dismissModal = (permanently: boolean = false) => {
    if (!currentLog) return;
    dismiss(currentLog.id, permanently);
  };

  // Wrapper for the quiz submission to pass all necessary context
  const handleSubmitQuiz = () => {
    if (!currentCampaign || !currentLog || !user) return;
    submitQuiz(currentCampaign, currentLog.id, user.id, questions);
  };

  // Wrapper for the next question function to pass the questions length
  const handleNextQuestion = () => {
    goToNextQuestion(questions.length);
  };

  return {
    loading,
    currentCampaign,
    questions,
    showModal,
    userAnswers,
    quizSubmitted,
    quizPassed,
    score,
    attemptNumber,
    currentQuestionIndex,
    dismissModal,
    handleAnswer,
    submitQuiz: handleSubmitQuiz,
    resetQuiz,
    goToPreviousQuestion,
    goToNextQuestion: handleNextQuestion,
    canDismiss
  };
};
